import { OverviewFacebook, requestFacebookParams } from '@/lib/analytics/pages/overview/facebook';
import {
    OverviewInstagram,
    requestInstagramOtherParameters,
    requestInstagramParams
} from '@/lib/analytics/pages/overview/instagram';
import {
    OverviewLinkedin,
    requestLinkedinOtherParameters,
    requestLinkedinParams
} from '@/lib/analytics/pages/overview/linkedin';
import {
    OverviewPinterest,
    requestPinterestParams
} from '@/lib/analytics/pages/overview/pinterest';
import {
    OverviewTiktokBusiness,
    requestTiktokBusinessOtherParameters,
    requestTiktokBusinessParams
} from '@/lib/analytics/pages/overview/tiktokBusiness';
import { OverviewTwitter, requestTwitterParams } from '@/lib/analytics/pages/overview/twitter';
import { OverviewYoutube, requestYoutubeParams } from '@/lib/analytics/pages/overview/youtube';
import {
    FACEBOOK,
    INSTAGRAM,
    LINKEDIN,
    PINTEREST,
    TIKTOK_BUSINESS,
    TWITTER,
    X,
    YOUTUBE
} from '@/lib/socialProfile';

export const OverviewConfig = (type) => {
    let config;
    let fields;
    let parameters;
    const waitForSPTransition = true;

    switch (type) {
        case INSTAGRAM:
            config = OverviewInstagram;
            fields = requestInstagramParams;
            parameters = requestInstagramOtherParameters;
            break;
        case FACEBOOK:
            config = OverviewFacebook;
            fields = requestFacebookParams;
            break;
        case LINKEDIN:
            config = OverviewLinkedin;
            fields = requestLinkedinParams;
            parameters = requestLinkedinOtherParameters;
            break;
        case TWITTER:
        case X:
            config = OverviewTwitter;
            fields = requestTwitterParams;
            break;
        case TIKTOK_BUSINESS:
            config = OverviewTiktokBusiness;
            fields = requestTiktokBusinessParams;
            parameters = requestTiktokBusinessOtherParameters;
            break;
        case YOUTUBE:
            config = OverviewYoutube;
            fields = requestYoutubeParams;
            break;
        case PINTEREST:
            config = OverviewPinterest;
            fields = requestPinterestParams;
            break;
    }
    return { config, fields, parameters, waitForSPTransition };
};
